import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FeedbackForm"*/ './lazyIndex')
);

export let FeedbackForm = createLazyComponent(lazyModule, m => m.FeedbackForm);
export let FeedbackRibbon = createLazyComponent(lazyModule, m => m.FeedbackRibbon);
export let NewConsumerRecruitmentForm = createLazyComponent(
    lazyModule,
    m => m.NewConsumerRecruitmentForm
);
export {
    FeedbackDialogParams,
    FeedbackCategory,
    FeedbackCompoundCategory,
} from './components/InlineFeedbackDialog';
export { FeedbackRibbonProps } from './components/FeedbackRibbon';
export { FeedbackFormProps } from './components/FeedbackForm';
export { ComponentClass } from 'react';
